import { _HTMLElement } from '../utils';
import { withAttributeReflection } from '../mixins/attribute-reflection';
import { withLifecycle } from '../mixins/lifecycle';
import { withUpdate } from '../mixins/update';

/**
 * The `withTextComponent` compound mixin is intended for the very simplest components that don't require styles or markup.
 *
 * Mixins used:
 * - `withAttributeReflection`
 * - `withLifecycle`
 * - `withUpdate`
 *
 * @category mixin - compound
 * @param {Class} [Base=HTMLElement] Optional base class to extend from.
 * @returns {Class}
 *
 * @example
```js
import { withTextComponent } from '@updater-legacy/components/custom-element';

class USCurrencyFormatter extends withTextComponent() {
  static props = ['value'];
  static reflectedAttributes = [
    { 
      name: 'disabled',
      boolean: true,
    },
    {
      name: 'type',
    }
  ];

  updated({ value }) {
    this.textContent = `$${value}`;
  }
}
 ```
 */
export const withTextComponent = (Base = _HTMLElement) =>
  class extends withUpdate(withAttributeReflection(withLifecycle(Base))) {};
